module.exports = __webpack_public_path__ + "static/media/arts_21.0799390d.jpg";